/* Self invoking anti-race condition function to run when actions happen */
(async function blogProducts() {
	productContentWidget();
	window.addEventListener('scroll', productContentWidget, { passive: true });
	window.addEventListener('resize', productContentWidget);

	await blogAds();
	if ( typeof searchTerms !== 'undefined' ) await defaultProductRec();
}())


/**
 * Display Ads put into content in the Information Center pages
 *
 * Uses [[product handle]] to display
 */
async function blogAds() {
	const blogContent = document.querySelector('.article-content');
	const pageContent = document.querySelector('.page');

	let content;
	if ( blogContent !== null ) {
		content = blogContent;
	} else if (  pageContent !== null ) {
		content = pageContent;
	} else {
		return;
	}

	if ( content ) {
		const element = content.innerHTML;
		const matches = element.match(/\[\[(.*?)\]\]/gi);
		if (matches) {
			matches.forEach((prodHandles, i) => {
			 	const adId = `blog-ad-${i}`;
			 	content.innerHTML = content.innerHTML.replace( prodHandles, `<div class="blog-product-section product-list" id="${adId}" style="--product-list-grid: auto-flow dense / repeat(2, minmax(0, 1fr));--product-list-gap:3rem 1.5rem;margin-bottom:50px;"></div>` );
			 	prodHandles = prodHandles.split(' ').join(); //remove spaces
			 	const handles = prodHandles.replace('[[', '').replace(']]', '').split(',');
				handles.forEach( async (productHandle) => {
					await getProducts(productHandle, adId);
			 	});
			});
		}
	}
}


/**
 * Gather product data and insert HTML
 */
async function getProducts(prodHandle, adId) {
	try {

		if ( !prodHandle || ( typeof prodHandle !== 'symbol' && prodHandle !== null && prodHandle !== '' && Number.isFinite(+prodHandle) ) ) return;

		const response = await fetch('/products/' + prodHandle + '.js', {
			method: "GET",
			headers: { "Content-Type": "application/json" }
		});

		if (response.ok) {

			const product = await response.json();
			const productBlock = document.getElementById(adId);
			const price = product.price / 100;
			const productHtml = `
				<product-card handle="${product.handle}" class="product-card product-card--blends bg-custom text-custom">
					<div class="product-card__figure">
						<a href="/products/${product.handle}" data-instant class="product-cart__image-link">
							<img src="${product.images[0]}" alt="${product.title}" loading="lazy" width="1" height="1" class="product-card__image product-card__image--primary object-fill-safe aspect-square" style="width:100%;margin-block:0;" />
						</a>
					</div>
					<div class="product-card__info" style="margin-top:0;">
						<div class="v-stack gap-0.5 w-full">
							<div class="rating-with-text">
								<span class="product-card__title"><a href="/products/${product.handle}" class="bold" data-instant>${product.title}</a></span>
							</div>
							<price-list class="price-list">$${price.toFixed(2)}</price-list>
							<a href="/products/${product.handle}" class="button button--full-width" style="margin-block-start: var(--spacing-3) !important;">View Details</a>
						</div>
					</div>
				</product-card>
			`;

			productBlock.innerHTML += productHtml;

		} else {

			throw new Error(`HTTP ${response.status}: ${await response.text()}`);

		}

	} catch (error) {

		console.error("Error getting items:", error);

	}
}



/**
 * Get default product rec form article title
 */
async function defaultProductRec() {

	try {

		if ( typeof recLimit == 'undefined' || typeof searchTerms == 'undefined' ) return;

		const response = await fetch(`${Shopify.routes.root}search/suggest.json?q=${searchTerms}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&resources[limit]=${recLimit}`, {
			method: "GET",
			headers: { "Content-Type": "application/json" }
		});

		if (response.ok) {

			const data = await response.json();
			const productSuggestions = data.resources.results.products;

			if (productSuggestions.length > 0) {

				const prodCards = document.querySelectorAll('.product-card__blog');

				prodCards.forEach((prodCard, i) => {

					if (productSuggestions[i] !== undefined) {

						const title = productSuggestions[i].title;
						const image = productSuggestions[i].featured_image;
						const handle = productSuggestions[i].handle;
						const price = productSuggestions[i].price;
						const url = productSuggestions[i].url;

						prodCard.setAttribute('handle', handle);

						prodCard.innerHTML = `<div class="product-card__figure">
										<a href="${url}" data-instant="" class="product-cart__image-link">
											<img src="${image.url}?v=1747936181&width=1000"
												alt="${image.alt}"
												srcset="${image.url}&width=200 200w,
														${image.url}&width=300 300w,
														${image.url}&width=400 400w,
														${image.url}&width=500 500w,
														${image.url}&width=600 600w,
														${image.url}&width=700 700w,
														${image.url}&width=800 800w,
														${image.url}&width=1000 1000w"
												width="1000"
												height="1000"
												sizes="(max-width: 699px) 74vw, (max-width: 999px) 38vw, calc((100vw - 96px) /  - (24px /  * -1))"
												class="product-card__image product-card__image--primary object-fill-safe aspect-square"
												loading="lazy"
											>
										</a>
									</div>
									<div class="product-card__info">
										<div class="v-stack gap-0.5 w-full">
											<div class="rating-with-text">
												<span class="product-card__title">
													<a href="${url}" class="bold" data-instant="">
														${title}
													</a>
												</span>
											</div>
											<price-list class="price-list  ">
												<sale-price class="text-subdued">
													$${price}
												</sale-price>
											</price-list>
										</div>
									</div>`
					}

				});
			}

		} else {

			throw new Error(`HTTP ${response.status}: ${await response.text()}`);

		}

	} catch (error) {

		console.error("Error getting product data from the API:", error);

	}
}




/*
	* Show/hide the product content widget when inside of blog article content container
	*/
function productContentWidget() {
	const prodWidget = document.querySelector('.product-widget');

	if ( prodWidget ) {
		const content = document.querySelector('.article-content');
		const rect = content.getBoundingClientRect();
		const offset = window.innerHeight * 0.3;
		const contentHasStarted = rect.top <= window.innerHeight - offset;
		const contentHasNotEnded = rect.bottom >= offset * 3;
		const show = contentHasStarted && contentHasNotEnded;

		prodWidget.classList.toggle('closed', !show);
	}

}
